import type { App } from 'vue'
import maskDirective from './mask'
import maxLengthDirective from './max-length'
import typeDirective from './type'

export default {
  install(app: App) {
    app.directive('type', typeDirective)
    app.directive('max-length', maxLengthDirective)
    app.directive('mask', maskDirective)
  }
}

export { maskDirective, maxLengthDirective, typeDirective }

